import React, { useReducer, createContext, useContext } from 'react';

const LiffContext = createContext();

const SET_PROFILE = 'SET_PROFILE';

const reducer = (state, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
};

const initialState = {
  profile: {
    ready: false,
    data: null,
  },
};

const LiffProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = {
    setProfile: (status) => {
      dispatch({ type: SET_PROFILE, payload: status });
    },
  };

  return (
    <LiffContext.Provider value={{ liffState: state, liffActions: actions }}>
      {children}
    </LiffContext.Provider>
  );
};

// Hook for easier usage
const useLiffContext = () => useContext(LiffContext);

export { LiffProvider, useLiffContext };
